"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESTRICTION_TYPE = void 0;
// #endregion Interfaces (1)
// #region Enums (1)
var RESTRICTION_TYPE;
(function (RESTRICTION_TYPE) {
    RESTRICTION_TYPE["PLANE"] = "plane";
    RESTRICTION_TYPE["GEOMETRY"] = "geometry";
})(RESTRICTION_TYPE = exports.RESTRICTION_TYPE || (exports.RESTRICTION_TYPE = {}));
// #endregion Enums (1)
//# sourceMappingURL=IRestriction.js.map